import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useV2Translation = () => {
    const { t } = useTranslation();

    const TRANSLATION_KEY = 'signup.organizationName.v2';
    const scopedTranslate = useCallback(
        (key: string) => t(`${TRANSLATION_KEY}.${key}`),
        [t],
    );

    const copy = useMemo(
        () => ({
            heading: scopedTranslate('heading'),
            fullNameLabel: scopedTranslate('fullNameLabel'),
            cityLabel: scopedTranslate('cityLabel'),
            islandNameLabel: scopedTranslate('islandNameLabel'),
            zipCodeLabel: scopedTranslate('zipCodeLabel'),
            unitedStates: scopedTranslate('unitedStates'),
            bahamas: scopedTranslate('bahamas'),
        }),
        [scopedTranslate],
    );

    return copy
};
